var $c48676dbfd01f32c$exports = {};
$c48676dbfd01f32c$exports = {
    "actions": `\u{64CD}\u{4F5C}`,
    "hideButtonLabel": `\u{663E}\u{793A}\u{66F4}\u{5C11}`,
    "noTags": `\u{65E0}`,
    "showAllButtonLabel": (args, formatter)=>`\u{5168}\u{90E8}\u{663E}\u{793A} (${formatter.number(args.tagCount)})`
};


export {$c48676dbfd01f32c$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
